import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_SUPERSCRIPT = 'superscript';

export const DEFAULTS_SUPERSCRIPT: Partial<PlatePluginOptions> = {
  hotkey: 'mod+,',
  clear: MARK_SUPERSCRIPT,
};
